import React from 'react'
import { Box, Button, Chip, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { ContentServiceFlowStatus } from './types'
import DeleteIcon from '@mui/icons-material/Delete'
import { deleteFlow } from './utility'

export function StatusState({
  flowStatus,
  statusDecorators,
  onFlowDelete,
}: {
  flowStatus: ContentServiceFlowStatus
  statusDecorators?: React.ReactNode
  onFlowDelete?: () => void
}) {
  const progressPercentage =
    flowStatus.meta.totalJobs > 0
      ? (flowStatus.meta.finishedJobs / flowStatus.meta.totalJobs) * 100
      : 0

  const successRatio = flowStatus.meta.totalJobs
    ? (flowStatus.meta.completedJobs / flowStatus.meta.totalJobs) * 100
    : 0
  const failRatio = flowStatus.meta.totalJobs
    ? (flowStatus.meta.failedJobs / flowStatus.meta.totalJobs) * 100
    : 0

  const successColor = '#4caf50'
  const errorColor = '#f44336'
  const warningColor = '#ffc947'

  const background =
    flowStatus.meta.totalJobs === 0
      ? warningColor
      : `linear-gradient(
          to right,
          ${successColor} 0%,
          ${successColor} ${successRatio}%,
          ${errorColor} ${successRatio}%,
          ${errorColor} ${successRatio + failRatio}%,
          ${warningColor} ${successRatio + failRatio}%,
          ${warningColor} 100%
        )`

  const flowId = flowStatus.meta.parameters.flow_id
  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2" fontWeight="medium">
          Flow Status
        </Typography>
        <Chip
          label={flowStatus.data.completed ? 'Completed' : 'Processing'}
          sx={{
            background,
            color: 'white',
          }}
          size="small"
        />
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <CircularProgress
          size={20}
          thickness={4}
          variant="determinate"
          value={progressPercentage}
        />
        <Typography variant="caption" color="text.secondary">
          {Math.round(progressPercentage)}%
        </Typography>
        {onFlowDelete && (
          <Button
            onClick={async () => {
              await deleteFlow(flowId)
              onFlowDelete()
            }}
          >
            <DeleteIcon color="warning" />
          </Button>
        )}
        {statusDecorators}
      </Box>
    </Box>
  )
}
